<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <admin-box-item title="공지사항 상세">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="제목">
                  {{ notice.title }}
                  <!--<input class="input"
                         :value="notice.title"
                         @input="e => notice.title = e.target.value"
                         :disabled="true"
                         type="text">-->
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="내용">
                  {{ notice.content }}
                  <!--<textarea class="textarea"
                            rows="10"
                            cols="10"
                            v-model="notice.content"
                            :disabled="true"></textarea>-->
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import AdminBoxItem from "../../../module/admin/AdminBoxItem";
  import AdminFormItem from "../../../module/admin/AdminFormItem";
  import AdminDatePicker from "../../../module/admin/AdminDatePicker";


  export default {
    layout: "Main",
    components: {
      AdminDatePicker,
      AdminFormItem,
      AdminBoxItem,
      SweetModal
    },
    created() {
        this.getData();
    },
    data() {
      return {
        notice: {
          id: 0,
          start_date: '',
          end_date: '',
          // date: {
          //   min: "2017-01-01",
          //   max: "2099-12-31"
          // },
          priority: 0,
          title: "",
          content: ""
        }
      };
    },
    methods: {
      getData() {
        this.$axios.get(this.masterBackendUrl + 'public/board/notice/' + this.$route.query.id)
          .then(res => {
            this.notice = res.data;
          });
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  @import '~assets/css/lp_main';

  .comment-sub-title {
    background: #ddd;
    color: #333;
    padding: 8px 16px;
    font-size: 0.95rem;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
  }

  .event-comment-content {
    padding: 20px;
    font-size: 0.95rem;
    color: #222;
    border-radius: 3px;
    border: none;
    background-color: #f2f7f8;
    display: block;
    width: 100%;
    height: 120px;
  }

  .btn-add-img {
    margin: 0 8px 8px 0;
    background: #f2f7f8;
    width: 80px;
    height: 80px;
    text-align: center;
  }

  .btn-add-img i {
    font-size: 3rem;
    line-height: 80px;
    color: #555;
  }
</style>
